// extracted by mini-css-extract-plugin
export default {"editable":"Mto5Yw","textType":"rLQKPp","textareaType":"B6eOZf","skeletonWrapper":"mPYWpR","dropdownMenu":"hPqCVT","menuItem":"c5SNH_","selected":"CnGbwR"};